// 白名单资源库
<template>
  <div class="white-resource-wrap threeLevelMain">
    <!-- 筛选条件区域 -->
    <div class="query-wrap">
      <el-form
        :inline="true"
        :model="queryForm"
        class="query-content"
        size="mini"
      >
        <el-form-item label="状态">
          <el-select
            v-model="queryForm.is_white"
            @change="queryHandle"
            clearable
          >
            <el-option label="未授权" value="0"></el-option>
            <el-option label="生效中" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业">
          <el-select
            v-model="queryForm.industry"
            placeholder="请选择平台"
            @change="queryHandle"
            clearable
          >
            <el-option
              v-for="(item, index) in commonOptions.categoryOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌名">
          <el-input
            v-model="queryForm.brand_name"
            clearable
            @input="queryHandle(1000)"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="店铺名">
          <el-input
            v-model="queryForm.shop_name"
            clearable
            @input="queryHandle(1000)"
          >
          </el-input>
        </el-form-item>
        <span>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            type="primary"
            @click="resetHandle"
          >
            重置筛选
          </el-button>
        </span>
      </el-form>
    </div>
    <!-- 平台筛选 tab页形式 -->
    <div class="plt-query-wrap">
      <el-tabs v-model="queryForm.platform" @tab-click="queryHandle">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="淘宝" name="淘宝"></el-tab-pane>
        <el-tab-pane label="京东" name="京东"></el-tab-pane>
        <el-tab-pane label="拼多多" name="拼多多"></el-tab-pane>
        <el-tab-pane label="其他平台" name="other"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 内容展示 -->
    <tablePageComp
      :orderNumConfig="{}"
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      :totalCount="totalCount"
      :pageSizeConfig="{
        pageSize: 20,
        pageSizeOption: [20, 50, 100, 200],
      }"
      :tableHeight="600"
    >
      <el-table-column slot="state" label="状态" align="center" width="80">
        <template slot-scope="{ row }">
          <span v-if="row.is_white == 1" class="fontColor_success">生效中</span>
          <span v-else-if="row.is_white == 0" class="fontColor_danger"
            >未授权</span
          >
        </template>
      </el-table-column>
      <el-table-column
        slot="shop_url"
        label="店铺链接"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <el-link
            v-if="row.shop_url"
            :href="row.shop_url"
            target="_blank"
            class="fontColor_theme"
          >
            查看
          </el-link>
          <span v-else>无</span>
        </template>
      </el-table-column>
    </tablePageComp>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      queryForm: {
        brand_name: "",
        industry: "",
        shop_name: "",
        platform: "all",
        is_white: "1",
      },
      dataList: [],
      columnsList: [
        { slotName: "state" },
        { label: "平台", prop: "platform", width: 100 },
        { label: "店铺名称", prop: "shop_name", width: 200 },
        { label: "品牌名", prop: "brand_name", width: 200 },
        { label: "行业", prop: "industry", width: 120 },
        { label: "掌柜昵称", prop: "shopkeeper_nick", width: 200 },
        { label: "店铺链接", slotName: "shop_url" },
        {
          label: "店长",
          prop: "shopowner_id",
          formatter: (row) => this.$tools.conversionName(row),
          width: 100,
        },
        {
          label: "组长",
          prop: "leader_id",
          formatter: (row) => this.$tools.conversionName(row),
          width: 100,
        },
        {
          label: "经营地址",
          prop: "business_address",
          width: 100,
          tooltip: true,
        },
        { label: "负责人", prop: "person", width: 100 },
        { label: "联系电话", prop: "person_phone", width: 100 },
      ],
      updateDataTag: false,
      resetPageNum: true,
      totalCount: 0,
    };
  },
  computed: {
    ...mapState(["commonOptions"]),
  },
  methods: {
    queryHandle(time = 0) {
      this.$tools.debounceFunc(
        function() {
          this.updateDataTag = !this.updateDataTag;
        }.bind(this),
        time
      );
    },
    resetHandle() {
      Object.keys(this.queryForm).forEach((key) => {
        this.queryForm[key] = "";
      });
      this.queryForm.platform = "all";
      this.queryForm.is_white = "1";
      this.updateDataTag = !this.updateDataTag;
    },
    dataFunc() {
      let paramObj = {};
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key] && this.queryForm[key] != "all") {
          paramObj[key] = this.queryForm[key];
        }
      });
      return {
        apiName: "getCustomWhiteList",
        paramObj,
        success: (res, callback) => {
          this.dataList = res.data.data.list;
          this.totalCount = res.data.data.count;
          if (callback) callback();
        },
        failed: (err, callback) => {
          console.log(err);
          if (callback) callback();
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.white-resource-wrap {
  .query-wrap {
    background: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 20px 10px 0;
    .query-content {
      .el-form-item {
        margin-left: 20px;
      }
    }
  }

  .plt-query-wrap {
    background: #fff;
    margin-top: 5px;
    padding: 0 20px;
  }
}
</style>
